// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2xhUf","info":"UpdateTermsInfo_info__3fT1b"};